export enum CredentialParameters {
  None = 0,
  // eslint-disable-next-line no-bitwise
  AutoImport = 1 << 0,
  // eslint-disable-next-line no-bitwise
  Synchronize = 1 << 1,
  // eslint-disable-next-line no-bitwise
  AllowDelete = 1 << 2
}

export const CredentialParametersMapping: Record<CredentialParameters, string> =
  {
    [CredentialParameters.None]: 'None',
    [CredentialParameters.AutoImport]: 'Auto Import',
    [CredentialParameters.Synchronize]: 'Synchronize',
    [CredentialParameters.AllowDelete]: 'Allow Remote Delete'
  };
